"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var scrollElementIntoView = function scrollElementIntoView(element) {
  if (element && element instanceof Element) {
    var prefersReducedMotion = window && typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    element.scrollIntoView({
      behavior: prefersReducedMotion ? 'auto' : 'smooth'
    });
  }
};

var _default = scrollElementIntoView;
exports["default"] = _default;